import { defer, EMPTY, MonoTypeOperatorFunction, of, throwError } from 'rxjs';
import { catchError, finalize, shareReplay, switchMap, tap } from 'rxjs/operators';

export function refCountShareReplay<T>(): MonoTypeOperatorFunction<T> {
  return source => source.pipe(shareReplay({ bufferSize: 1, refCount: true }));
}

let observableId = 0;

export function log<T>(name = 'unnamed observable'): MonoTypeOperatorFunction<T> {
  const label = `${name} ($${++observableId})`;

  return source => defer(() => {
    console.log(`${label}: subscribed`);

    return source.pipe(
      tap({
        next: value => console.log(`${label}:`, value),
        complete: () => console.log(`${label}: completed`),
      }),
      finalize(() => console.log(`${label}: unsubscribed`)),
    );
  });
}

export function callOnSuccessOnError<T>(
  onSuccess?: onSmartSuccess,
  onError?: onSmartFailure,
  getAdditionalError?: (next: T) => string | undefined): MonoTypeOperatorFunction<T> {

  return source => source.pipe(
    switchMap(next => {
      if (!getAdditionalError) return of(next);

      const errorStr = getAdditionalError(next);
      return errorStr ? throwError(new Error(errorStr)) : of(next);
    }),
    catchError(err => {
      onError && onError(err);
      return throwError(err);
    }),
    tap(onSuccess));
}

function neutralizeErrors<T>(): MonoTypeOperatorFunction<T> {
  return source => source.pipe(catchError(() => EMPTY));
}
